import React from 'react';
import {
	Card,
	Col,
	Row,
} from 'antd';
import { CargoContractSides } from '@shared/utils/constants';
import PaymentsTable from '@client/screens/fleet/VoyageDetailsScreen/components/PaymentsTable';
import FreightInvoicesTable from '@client/screens/fleet/VoyageDetailsScreen/components/InvoiceTables/FreightInvoicesTable';
import CargoContractSideTag from '@client/screens/cargos/details/utils/CargoContractSideTag';
import { useVoyage } from '../VoyageProvider/VoyageProvider';

const FreightInvoices = () => {
	const { hasCargoRelet, cargos } = useVoyage();

	const vcOutCargo = cargos?.find(
		cargo => cargo.contractSide === CargoContractSides.VC_OUT,
	);

	const vcInCargo = cargos?.find(
		cargo => cargo.contractSide === CargoContractSides.VC_IN,
	);

	const tabLabel = (
		contractSide: CargoContractSides,
		chartererName?: string | null,
	) => (
		<>
			<CargoContractSideTag contractSide={contractSide} />
			{chartererName}
		</>
	);

	const content = (contractSide?: CargoContractSides) => (
		<Row gutter={[16, 16]}>
			<Col xl={12} xxl={8}>
				<PaymentsTable cargoContractSide={contractSide} />
			</Col>
			<Col xl={24} xxl={16}>
				<FreightInvoicesTable cargoContractSide={contractSide} />
			</Col>
		</Row>
	);

	return hasCargoRelet ?
		(
			<Card
				tabList={[
					{
						key: CargoContractSides.VC_OUT,
						label: tabLabel(
							CargoContractSides.VC_OUT,
							vcOutCargo?.FixtureCounterparty?.name,
						),
						children: content(CargoContractSides.VC_OUT),
					},
					{
						key: CargoContractSides.VC_IN,
						label: tabLabel(
							CargoContractSides.VC_IN,
							vcInCargo?.FixtureCounterparty?.name,
						),
						children: content(CargoContractSides.VC_IN),
					},
				]}
			/>
		) :
		content();
};

export default FreightInvoices;
